import React from "react";
import { useI18n } from "../i18n/I18nContext.js";

export interface CategoryBarProps {
  selectedCategory: string;
  onSelectCategory: (category: string) => void;
}

export const CategoryBar: React.FC<CategoryBarProps> = ({
  selectedCategory,
  onSelectCategory,
}) => {
  const { t } = useI18n();

  const categories = [
    { id: "All", label: t.nav.all },
    { id: "Music", label: t.nav.music },
    { id: "Podcasts", label: t.nav.podcasts },
    { id: "Tech", label: t.nav.tech },
    { id: "Entertainment", label: t.nav.entertainment },
    { id: "Cinema", label: t.nav.cinema || "Cinema" },
    { id: "Gaming", label: t.nav.gaming },
  ];

  return (
    <div className="w-full flex overflow-x-auto no-scrollbar py-2 px-1 items-center gap-2 select-none border-b border-zinc-800/60 font-sans touch-pan-x">
      {categories.map((cat) => {
        const isSelected = selectedCategory === cat.id;

        return (
          <button
            key={cat.id}
            onClick={() => onSelectCategory(cat.id)}
            className={`px-3.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-all border ${
              isSelected
                ? "bg-white text-zinc-950 border-white shadow-md font-bold"
                : "bg-zinc-900/90 hover:bg-zinc-800 text-zinc-300 border-zinc-800"
            }`}
          >
            {cat.label}
          </button>
        );
      })}
    </div>
  );
};
